//
//
//
//
//
//

import item from './item';
  export default {
      name: "tabbar",
    components:{
        item
    },
    data(){
        return{
          selected:'/tutorial',
        }
    },
    props:{
      data:Array
    },
    methods:{
      routeChanged(e){
        this.selected=e;
      }
    },
    created() {
        this.selected=this.$route.path;
    }
  }



// WEBPACK FOOTER //
// ./src/components/common/tabbar/tabbar.vue